<template>
  <div>
    <el-dialog :title="titleName" width="30%" :visible.sync="visible">
      <el-form
        ref="form"
        :model="form"
        size="small"
        label-width="150px"
        :rules="rules"
      >
        <el-form-item label="文件名称：" prop="name">
          <el-input style="width: 80%" type="text" v-model="form.name" />
        </el-form-item>
        <el-form-item label="文件类型：" prop="serveType">
          <el-select
            style="width: 100%"
            size="small"
            filterable
            clearable
            v-model="form.serveType"
            placeholder="请选择文件类型"
          >
            <el-option
              v-for="item in serveTypes"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="label" prop="file1">
          <el-upload
            action="#"
            :limit="1"
            :on-change="handleChangeReviewPic"
            :on-remove="handleRemove"
            :auto-upload="false"
            :file-list="form.file1"
            :on-exceed="exceedNum"
            :accept="accept"
          >
            <el-button style="width: 120px" type="primary"
              >选择文件...</el-button
            >
            <div slot="tip" class="el-upload__tip">
              {{ tip }}
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="GLOBAL.token" @click="visible = false"
          >取 消</el-button
        >
        <el-button :size="GLOBAL.token" type="primary" @click="submit('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "上传文件",
    },
    accept: {
      type: String,
      default: [".xlsx", ".xls"].join(","),
    },
    tip: {
      type: String,
      default: " 每次最多上传一份文件！",
    },
    url: {
      type: String,
      required: true,
    },
    titleName: {
      type: String,
      default: "上传",
    },
    serveTypes: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      visible: false,

      form: {
        file1: [],
        file: [],
        name: "",
        serveType: "",
      },
      rules: {
        file1: [
          {
            required: true,
            message: "请上传附件",
            trigger: "change",
          },
        ],
      },
    };
  },

  //监控data中的数据变化
  watch: {},
  mounted() {},
  methods: {
    exceedNum() {
      this.$message({
        message: "最多上传一个文件！",
        type: "warning",
      });
    },
    // 上传附件
    handleChangeReviewPic(file, fileList) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message({
          message: "文件大小不可以超过10M",
          type: "warning",
        });
        this.form.file1 = [];
        return false;
      }

      const suffix = file.name.substring(file.name.lastIndexOf("."));
      const accept = this.accept.split(",");

      if (!accept.includes(suffix)) {
        this.$message({
          message: `不支持上传${suffix}类型的文件`,
          type: "warning",
        });
        this.form.file1 = [];
        return false;
      }
      let arr = [];
      fileList.map((item) => {
        arr.push(item.raw);
      });
      this.form.file = arr;
      this.form.file1 = fileList;
    },
    // 删除附件
    handleRemove(file, fileList) {
      if (file.id) {
        this.form.plandel.push(file.id);
      }
      let arr = [];
      fileList.map((item) => {
        arr.push(item.raw);
      });
      this.form.file = arr;
      this.form.file1 = fileList;
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let datas = this.form;
          // let url = ` ${this.$api.envManualFiles.upload}?name=${datas.name}&number=${datas.number}`
          let url = `${this.$api.moreServicesV2.upload}`;
          let formData = new FormData(); //  用FormData存放上传文件
          for (let p in datas) {
            if (datas.hasOwnProperty(p)) {
              let data = datas[p];
              if (Array.isArray(data)) {
                if (p === "file") {
                  data.forEach((t) => {
                    if (t) {
                      formData.append(p, t);
                    }
                  });
                }
              } else {
                formData.append(p, data);
              }
            }
          }
          console.log(formData);
          this.$axios.post(url, formData, false).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.visible = false;
              this.$emit("getData");
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>